<template>
  <draggable :list="list" class="table-drag" v-bind="dragOptions">
    <div class="column-item" v-for="i in list" :key="i.prop" v-show="!isDisabled(i)">
      <i class="iconfont iconSort drag-icon icon move" title="移动"></i>
      <el-checkbox v-model="i.active" :disabled="isDisabled(i)">{{ language[i.prop] || i.label }}</el-checkbox>
    </div>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  name: 'DraggableList',
  components: {
    draggable,
  },
  props: {
    list: {
      type: Array,
    },
    fixTableHeaderList: {
      type: Array,
      default: () => [],
    },
    textlist: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    dragOptions() {
      return {
        handle: '.drag-icon',
        dragClass: 'drag-item',
        chosenClass: 'chosenClass',
        forceFallback: true,
        animation: 100,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        scrollSensitivity: 100,
        fallbackTolerance: 1,
        bubbleScroll: true,
        scrollSpeed: 2000,
        scroll: true,
      }
    },
    language() {
      let name = {}
      this.textlist.forEach(el => {
        name[el.prop] = el.label
      })
      return name
    },
  },
  methods: {
    isDisabled(row) {
      return this.fixTableHeaderList.includes(row.prop)
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #010517;
}
.table-drag {
  padding-bottom: 16px;
  color: #c4c8d0;
}
.move {
  cursor: move;
}
.column-item {
  height: 48px;
  background: #ffffff;
  border: 1px solid #dfe3e9;
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-top: 12px;
  ::v-deep {
    .el-checkbox {
      margin: 0 $--base-margin;
    }
  }
}
.column-item.drag-item {
  opacity: 1 !important;
  cursor: move !important;
  background-color: #fff;
}
</style>
